import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import TermsTextRenderer from '../controls/TermsTextRenderer';
import CheckboxField from '../fields/CheckboxField';
import NavRow from '../fields/NavRow';
import { TaskDefinition, TaskStepRenderArgs } from '../QuestionnaireShell';
import { TermsValues } from '../types';
import { zodResolver } from '../validation';

const schema = z.object({
  serviceAgreement: z.boolean().refine((v) => v === true, { message: 'You must agree to continue' }),
});

const DEFAULTS: TermsValues = { serviceAgreement: false };

const TermsForm = ({ initialValues, onComplete, onBack, onCancelEdit, submitLabel }: TaskStepRenderArgs) => {
  const defaults = (initialValues as TermsValues | undefined) ?? DEFAULTS;
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<TermsValues>({
    defaultValues: defaults,
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit((values) => onComplete(values));

  return (
    <form className="rnq-form" onSubmit={(e) => e.preventDefault()}>
      <TermsTextRenderer />
      <CheckboxField control={control} name="serviceAgreement" label="I agree to these terms and conditions" required />
      <NavRow
        onBack={onBack}
        onCancelEdit={onCancelEdit}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        disabled={!isValid}
      />
    </form>
  );
};

const Terms: TaskDefinition = {
  key: 'task16',
  label: 'Terms',
  title: 'Terms of service',
  render: (args) => <TermsForm {...args} />,
};

export default Terms;
